import React from "react";

function CloudOneIcon(props) {
  return (
    <svg
      width="75"
      height="66"
      viewBox="0 0 75 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M39.0304 15.6767C38.8806 16.1791 39.1668 16.707 39.6688 16.8568L39.7685 16.8865L39.7728 16.8815C40.2437 16.9666 40.7107 16.6847 40.849 16.2176C42.1099 11.9811 46.0821 9.02151 50.5077 9.02151C51.0316 9.02151 51.4566 8.59656 51.4566 8.07262C51.4566 7.54867 51.0316 7.12373 50.5077 7.12373C45.0687 7.12373 40.4981 10.745 39.0304 15.6767ZM39.0304 15.6767L39.1851 15.7228M39.0304 15.6767C39.0304 15.6767 39.0304 15.6767 39.0304 15.6768L39.1851 15.7228M39.1851 15.7228C39.0608 16.1396 39.2982 16.5778 39.715 16.7021L39.1851 15.7228Z"
        fill="#8b58f1"
        stroke="#F9FFF9"
        stroke-width="0.322847"
      />
      <path
        d="M61.5314 46.6586H56.8067C56.3719 46.6586 56.0192 46.306 56.0192 45.8712C56.0192 45.4364 56.3719 45.0837 56.8067 45.0837H61.5314C68.0442 45.0837 73.3432 39.7846 73.3432 33.2719C73.3432 26.7591 68.0442 21.46 61.5314 21.46H61.4178C61.1894 21.46 60.9723 21.361 60.8227 21.1884C60.6731 21.0157 60.6056 20.7868 60.6382 20.5606C60.7085 20.0702 60.7439 19.5775 60.7439 19.0977C60.7439 13.4533 56.1513 8.8607 50.507 8.8607C48.3111 8.8607 46.217 9.54691 44.4508 10.8456C44.0627 11.1308 43.5115 11.0043 43.287 10.5773C38.285 1.05253 25.2203 -0.226557 18.4469 8.05919C15.5936 11.5499 14.4724 16.0907 15.3708 20.5163C15.4698 21.005 15.0958 21.4606 14.5991 21.4606H14.2836C7.77078 21.4606 2.47172 26.7597 2.47172 33.2725C2.47172 39.7853 7.77078 45.0843 14.2836 45.0843H19.0082C19.443 45.0843 19.7957 45.437 19.7957 45.8718C19.7957 46.3066 19.443 46.6592 19.0082 46.6592H14.2836C6.90222 46.6592 0.896729 40.6538 0.896729 33.2724C0.896729 26.0982 6.56974 20.2237 13.6654 19.8997C12.9989 15.3082 14.2734 10.6769 17.2275 7.06251C24.4794 -1.80929 38.3771 -0.814881 44.2519 9.07782C46.1262 7.90282 48.2708 7.28642 50.5067 7.28642C57.3452 7.28642 62.764 13.1069 62.2899 19.9071C69.3202 20.3013 74.9179 26.1448 74.9179 33.2719C74.9179 40.6538 68.9124 46.6587 61.531 46.6587L61.5314 46.6586Z"
        fill="#8b58f1"
      />
      <path
        d="M17.9538 45.4249C17.9538 56.3694 26.8576 65.273 37.8019 65.273C48.7463 65.273 57.6499 56.3692 57.6499 45.4249C57.6499 34.4805 48.7463 25.5769 37.8019 25.5769C26.8574 25.5769 17.9538 34.4806 17.9538 45.4249ZM19.8519 45.4249C19.8519 35.5276 27.9044 27.475 37.8019 27.475C47.6992 27.475 55.7518 35.5275 55.7518 45.4249C55.7518 55.3222 47.6992 63.3749 37.8019 63.3749C27.9046 63.3749 19.8519 55.3223 19.8519 45.4249Z"
        fill="#8b58f1"
        stroke="#F9FFF9"
        stroke-width="0.322847"
      />
      <path
        d="M37.424 53.351C37.424 53.7585 37.7545 54.0889 38.162 54.0889C38.5694 54.0889 38.8999 53.7589 38.8999 53.351V38.3617C38.8999 37.9542 38.5694 37.6237 38.162 37.6237C37.7545 37.6237 37.424 37.9542 37.424 38.3617V53.351Z"
        fill="#8b58f1"
        stroke="#B2CFF1"
        stroke-width="0.322847"
      />
      <path
        d="M38.1618 39.4054L34.0717 43.4955C33.7837 43.784 33.3162 43.7838 33.0279 43.4956C32.7396 43.2073 32.7396 42.7403 33.0279 42.452L37.6399 37.8401L38.1618 39.4054ZM38.1618 39.4054L42.252 43.4956C42.3959 43.6395 42.5853 43.7117 42.7738 43.7117L38.1618 39.4054ZM42.7738 43.7117C42.962 43.7117 43.1515 43.6401 43.2957 43.4955L42.7738 43.7117Z"
        fill="#8b58f1"
        stroke="#B2CFF1"
        stroke-width="0.322847"
      />
    </svg>
  );
}

export default CloudOneIcon;
